<template>
  <w-settings-content-template>
    <el-row slot="title" style="padding-right:20px; width:100%;" type="flex" justify="space-between" align="middle">
      <div style="line-height:28px;">작업 그룹</div>
      <div v-show="treeEditFlag">
        <el-button type="solid" @click="saveEditedGroup">저장</el-button>
        <el-button @click="cancelEditedGroup">취소</el-button>
      </div>
      <el-button v-show="!treeEditFlag" type="solid" @click="editGroup">편집</el-button>
    </el-row>
    <w-job-group-tree-view slot="sideContent" bclass="mr-r20" ref="jobGroupTreeView" @load-job-list="loadJobList" @end-edit="treeEditFlag = false"></w-job-group-tree-view>
    <div slot="content">
      <w-job-list-view :selected-group-data="selectedGroupData" @show-job-detail="showJobDetail" ref="jobListView"></w-job-list-view>
      <w-job-detail-list-popup :selected-job="selectedJob" ref="jobDetailListPopup"></w-job-detail-list-popup>
    </div>
  </w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WJobGroupTreeView from './components/JobGroupTreeView';
import WJobListView from './components/JobListView';
import WJobDetailListPopup from './popup/JobDetailListPopup';

export default {
  name: 'WJobSetting',
  components: {
    WSettingsContentTemplate,
    WJobGroupTreeView,
    WJobListView,
    WJobDetailListPopup,
  },
  data() {
    return {
      selectedGroupData: null,
      selectedJob: {},
      treeEditFlag: false,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$refs.jobGroupTreeView.loadData();
    },
    loadJobList(groupData) {
      this.selectedGroupData = groupData.original;
      // this.$nextTick(() => {
      //   this.$refs.jobListView.loadData();
      // });
    },
    showJobDetail(selectedJob) {
      this.selectedJob = selectedJob;
      this.$nextTick(() => {
        this.$refs.jobDetailListPopup.open();
      });
    },
    /**
     * 그룹 트리를 편집한다.
     * @return {[type]} [description]
     */
    editGroup() {
      this.treeEditFlag = true;
      this.$refs.jobGroupTreeView.edit();
    },
    /**
     * 그룹 트리 편집 사항을 저장한다.
     * @return {[type]} [description]
     */
    saveEditedGroup() {
      this.$refs.jobGroupTreeView.saveChangeGroupTree();
    },
    /**
     * 그룹 트리 편집 사항을 취소한다.
     * @return {[type]} [description]
     */
    cancelEditedGroup() {
      this.$refs.jobGroupTreeView.cancelChangeGroupTree();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/JobSetting/index.vue